<div class="row mt-3">
  <app-progress-bar [isLoading]="isLoadingFilters"></app-progress-bar><div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Date From</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="picker" (click)="picker.open()" (dateChange)="getMasterFilters()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="fromDate" placeholder="From"
          [(ngModel)]="auditTrailFilters.fromDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="picker.open()"></span>
        </div>
      </div>
      <mat-datepicker #picker></mat-datepicker>
    </div>
  </div>

  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label d-none d-sm-block mb-1">Date Until</div>
      <div class="input-group input-group-sm">
        <input matInput [matDatepicker]="toPicker" (click)="toPicker.open()" (dateChange)="getMasterFilters()" placeholder="Choose a date"
          class="form-control form-control-sm border-bottom" id="toDate" placeholder="To"
          [(ngModel)]="auditTrailFilters.toDate" readonly>
        <div class="input-group-append">
          <span class="input-group-text fa fa-calendar" (click)="toPicker.open()"></span>
        </div>
      </div>
      <mat-datepicker #toPicker></mat-datepicker>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">User</div>
      <mat-chip-grid #userList>
        <mat-chip-row *ngFor="let user of auditTrailFilters.users" [selectable]="selectable"
          [removable]="removable" (removed)="removeUser(user)">
          {{user}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #userInput
          [formControl]="searchUserCntrl" [matAutocomplete]="userAutocomplete"
          [matChipInputFor]="userList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="addOnBlur" autocomplete="off" (matChipInputTokenEnd)="addUser($event)">
      </mat-chip-grid>
      <mat-autocomplete #userAutocomplete="matAutocomplete" (optionSelected)="selectedUserEvent($event)">
        <mat-option *ngFor="let user of searchedUsers" [value]="user.value">
          {{user.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Screen</div>
      <mat-chip-grid #screenList>
        <mat-chip-row *ngFor="let screen of auditTrailFilters.screens" [selectable]="selectable" [removable]="removable"
          (removed)="removeScreen(screen)">
          {{screen}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #screenInput [formControl]="searchScreenCntrl"
          [matAutocomplete]="screenAutocomplete" [matChipInputFor]="screenList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addScreen($event)">
      </mat-chip-grid>
      <mat-autocomplete #screenAutocomplete="matAutocomplete" (optionSelected)="selectedScreenEvent($event)">
        <mat-option *ngFor="let screen of searchedScreens" [value]="screen.value">
          {{screen.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Function</div>
      <mat-chip-grid #functionList>
        <mat-chip-row *ngFor="let function of auditTrailFilters.functions" [selectable]="selectable"
          [removable]="removable" (removed)="removeFunction(function)">
          {{function}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #functionInput [formControl]="searchFunctionCntrl"
          [matAutocomplete]="functionAutocomplete" [matChipInputFor]="functionList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addFunction($event)">
      </mat-chip-grid>
      <mat-autocomplete #functionAutocomplete="matAutocomplete" (optionSelected)="selectedFunction($event)">
        <mat-option *ngFor="let function of searchedFunctions" [value]="function.value">
          {{function.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3">
    <div class="form-group">
      <div class="left inline control-label mb-1">Action</div>
      <mat-chip-grid #actionList>
        <mat-chip-row *ngFor="let action of auditTrailFilters.actions" [selectable]="selectable"
          [removable]="removable" (removed)="removeAction(action)">
          {{action}}
          <mat-icon matChipRemove *ngIf="removable">x</mat-icon>
        </mat-chip-row>
        <input class="form-control form-control-sm mat-autodd-input" #actionInput [formControl]="searchActionCntrl"
          [matAutocomplete]="actionAutocomplete" [matChipInputFor]="actionList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="addOnBlur" autocomplete="off"
          (matChipInputTokenEnd)="addAction($event)">
      </mat-chip-grid>
      <mat-autocomplete #actionAutocomplete="matAutocomplete" (optionSelected)="selectedAction($event)">
        <mat-option *ngFor="let action of searchedActions" [value]="action.value">
          {{action.name}}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="col-md-3 col-lg-3 float-right text-right pt-4">
    <div class="form-group">
      <button type="button" class="btn btn-sm bg-purple text-white ml-2 float-lg-right text-right btn-blue text-white"
        id="btn-search" (click)="TriggerAction()">Submit</button>
      <span class="float-right ml-2 btn btn-sm pl-1" (click)="initFilters()">Reset</span>
    </div>
  </div>
</div>
